import { Navigate, useRoutes } from "react-router-dom";
// auth
import AuthGuard from "../auth/AuthGuard";
import GuestGuard from "../auth/GuestGuard";
// layouts
import CompactLayout from "../layouts/compact";
import DashboardLayout from "../layouts/dashboard";
// config
import { PATH_AFTER_LOGIN } from "../config";
//
import {
  Page404,
  Login,
  Dashboard,
  Deposits,
  Commissions,
  Reward,
  Withdraw,
  Settings,
  Currency,
  Users,
  ClaimedRewards,
} from "./elements";
import GuestLayout from "src/layouts/Guest/GuestLayout";

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: (
        <GuestGuard>
          <GuestLayout />
        </GuestGuard>
      ),
      children: [
        { element: <Navigate to={"/login"} replace />, index: true },
        { path: "login", element: <Login /> },
      ],
    },
    {
      path: "/dashboard",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: "dashboard", element: <Dashboard /> },
        { path: "users", element: <Users /> },
        { path: "currency", element: <Currency /> },
        { path: "deposits", element: <Deposits /> },
        { path: "withdraw", element: <Withdraw /> },
        { path: "reward", element: <Reward /> },
        { path: "ClaimedRewards", element: <ClaimedRewards /> },
        { path: "commissions", element: <Commissions /> },
        { path: "settings", element: <Settings /> },
      ],
    },
    {
      element: <CompactLayout />,
      children: [{ path: "404", element: <Page404 /> }],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
